module.exports = __webpack_public_path__ + "static/img/logo_longgang.c1105cf1.png";